import { Endpoints } from '~/enums'
import API from './client'

const client = API()

export const getHighScores = () => {
	return client.get<{ name: string; score: number }[]>(Endpoints.highscores)
}

export const test = () => {
	return client.get(Endpoints.test)
}

export const login = (username: string, password: string) => {
	return client.post(Endpoints.login, { data: { username, password } })
}
